import {gql, useMutation} from '@apollo/client';
import {useSnackbar} from 'notistack';
import {useAccountContext} from '../contexts/AccountContext';
import {GET_ACCOUNT_REVIEWS} from '../components/AccountOverview/accountOverviewQueries';

export const RE_SYNC_REVIEW = gql`
  mutation ReSyncReview($reviewID: UUID!) {
    reSyncReview(reviewId: $reviewID) {
      ok
      errors
      review {
        id
        isInJourney
      }
    }
  }
`;

export default function useReSyncReview(onlyCurrent: boolean) {
  const {account} = useAccountContext();

  const {enqueueSnackbar} = useSnackbar();
  const [reSyncReview] = useMutation(RE_SYNC_REVIEW, {
    refetchQueries: [
      {
        query: GET_ACCOUNT_REVIEWS,
        variables: {
          accountId: account?.id,
          idType: 'id',
          onlyCurrent,
        },
      },
    ],
    awaitRefetchQueries: true,
    onCompleted(data, clientOptions) {
      if (data?.reSyncReview?.ok) {
        enqueueSnackbar({
          message: 'Sync with Curo successful',
          variant: 'success',
        });
        return;
      }
      enqueueSnackbar({
        message: 'Sync with Curo failed',
        variant: 'error',
        autoHideDuration: null,
      });
    },
    onError() {
      enqueueSnackbar({
        message: 'Sync with Curo failed',
        variant: 'error',
        autoHideDuration: null,
      });
    },
  });

  return {
    reSyncReview,
  };
}
